import { Injectable, inject } from '@angular/core';

import { WidgetPage } from '@frontend/sports/types/components/widget';
import { NavigationRouterService } from '@frontend/sports/web/navigation-data-access';
import { WidgetContextService } from '@frontend/sports/widget/core/feature';
import { WidgetLayoutHook } from '@frontend/sports/widget/feature/layout';

@Injectable({ providedIn: 'root' })
export class SportNavigationHighlightService extends WidgetLayoutHook {
    private navigationRouter = inject(NavigationRouterService);
    private context = inject(WidgetContextService);

    constructor() {
        super(WidgetPage.SportLobby);
    }

    onResolve(): void {
        const { sportId } = this.context.getContext();

        if (sportId) {
            this.navigationRouter.setNavigation(sportId.toString());
        }
    }

    onDestroy(): void {
        this.navigationRouter.resetNavigation();
    }
}
